import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, bootstrapping } = useSelector((state) => state.auth)
  const { slug } = useParams()

  // Mostrar loading mientras se verifica la autenticación (incluye el chequeo
  // inicial de sesión Clerk/Supabase, para no expulsar al usuario en el refresh).
  if (loading || bootstrapping) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="var(--cd-full-vh, 100vh)"
      >
        <CircularProgress size={60} />
      </Box>
    )
  }

  // Sin sesión → cae en la vista pública de la compañía (no en el login).
  // Backstop de TenantRoute; mantiene la misma semántica company-first. Si no hay
  // slug (caso raro fuera del árbol de tenant), va al login global.
  if (!isAuthenticated) {
    return <Navigate to={slug ? `/${slug}/portal` : '/login'} replace />
  }

  // Si está autenticado, mostrar el contenido protegido
  return children
}

export default ProtectedRoute